module.exports = __webpack_public_path__ + "static/media/rsz_1banner_slider1.1347a398.jpg";